module.exports = __webpack_public_path__ + "/images/ico-max-click.676ab5f.svg";